import { TableHeaderData } from "../types/types";

export const TABLE_HEADER_RU: TableHeaderData[] = [
  {
    id: "chat_id",
    label: "ID Чата",
    small: true,
  },
  {
    id: "chat_name",
    label: "Имя Чата",
  },
  {
    id: "asst_name",
    label: "Имя Ассистента",
  },
];

export const TABLE_HEADER_EN: TableHeaderData[] = [
  {
    id: "chat_id",
    label: "Chat's ID",
    small: true,
  },
  {
    id: "chat_name",
    label: "Chat's Name",
  },
  {
    id: "asst_name",
    label: "Assistant's Name",
  },
];

export const TABLE_HEADER_HY: TableHeaderData[] = [
  {
    id: "chat_id",
    label: "Զրույցի ID",
    small: true,
  },
  {
    id: "chat_name",
    label: "Զրուցարան Անուն",
  },
  {
    id: "asst_name",
    label: "Օգնականի անունը",
  },
];
